import { DataSnapshot } from 'firebase/database';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SnapshotAction } from '@shared/services/database-wrapper.service';

export function mapListKeys<T>(name: string = '$key') {
  return (source: Observable<SnapshotAction<T>[]>) =>
    source.pipe(
      map((list) =>
        list
          ? list.map((object: SnapshotAction<DataSnapshot>) => ({
              [name]: object.key,
              ...(object.payload.val() as T),
            }))
          : null,
      ),
    );
}
